import { FormInstance } from "antd";
import { Point } from "tm-shared/types";

import { PageBlock } from "@/shared/pageComposition/BlockList";

import { RouteEditorFormValues } from "../components/RouteEditorForm";
import { useScheduleSelection } from "../hooks";
import { RouteEditorCapabilities } from "../RouteEditor.policy";
import { RouteEditorModalState } from "../RouteEditor.types";
import { RouteEditorCreateMainContentBlock } from "./blocks/RouteEditorCreateMainContentBlock";
import { RouteEditorCreateMetaAndHeaderBlock } from "./blocks/RouteEditorCreateMetaAndHeaderBlock";
import { RouteEditorCreateModalsBlock } from "./blocks/RouteEditorCreateModalsBlock";

export type RouteEditorCreateModel = {
    capabilities: RouteEditorCapabilities;
    schedulesLoading: boolean;
    saveLoading: boolean;
    routeEditorForm: FormInstance<RouteEditorFormValues>;
    points: Record<string, Point>;
    modalState: RouteEditorModalState;
    selection: ReturnType<typeof useScheduleSelection>;
    handlers: {
        handleSave: () => void;
        setModalState: (state: RouteEditorModalState) => void;
    };
};

export const getRouteEditorCreateBlocks = (
    model: RouteEditorCreateModel,
): PageBlock<RouteEditorCreateModel>[] => [
    {
        key: "route-editor-create-meta-and-header",
        order: 10,
        render: () => (
            <RouteEditorCreateMetaAndHeaderBlock
                selection={model.selection}
                onSetModalState={model.handlers.setModalState}
            />
        ),
    },
    {
        key: "route-editor-create-main-content",
        order: 20,
        render: () => (
            <RouteEditorCreateMainContentBlock
                routeEditorForm={model.routeEditorForm}
                schedulesLoading={model.schedulesLoading}
                points={model.points}
                saveLoading={model.saveLoading}
                selection={model.selection}
                onSave={model.handlers.handleSave}
                onSetModalState={model.handlers.setModalState}
            />
        ),
    },
    {
        key: "route-editor-create-modals",
        order: 30,
        render: () => (
            <RouteEditorCreateModalsBlock
                modalState={model.modalState}
                onSetModalState={model.handlers.setModalState}
                onExitMultiSelectMode={model.selection.exitMultiSelectMode}
            />
        ),
    },
];
